import { useContext } from 'react';

import NotificationContext from 'context/NotificationContext';

export const useNotify = () => {
	return useContext(NotificationContext);
};
